module.exports = __webpack_public_path__ + "img/icon-waiting.5a2f8f40.png";